import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation, useQueryClient } from "react-query";

export const useUpdatePrimaryInfo = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const updatePrimaryInfo = async ({ vesselId, primaryInfo }) => {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/vessel/update/primaryInformation/${vesselId}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(primaryInfo),
      }
    );

    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(errorResponse.message || "Failed to update primary information");
    }

    return response.json();
  };

  return useMutation(updatePrimaryInfo, {
    onSuccess: () => {
      queryClient.invalidateQueries("vessels");
    },
    onError: (error) => {
      console.error("Error updating primary information:", error);
    },
  });
};
